import { useEffect } from 'react';

const MetaTags = ({ 
  title, 
  description, 
  image, 
  url, 
  type = 'website',
  siteName = 'OmniRises Jobs',
  keywords 
}) => {
  useEffect(() => {
    // Update page title
    if (title) {
      document.title = title;
    }

    // Helper function to update or create meta tags
    const updateMetaTag = (property, content, nameAttr = 'property') => {
      if (!content) return;
      
      let metaTag = document.querySelector(`meta[${nameAttr}="${property}"]`);
      if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.setAttribute(nameAttr, property);
        document.head.appendChild(metaTag);
      }
      metaTag.setAttribute('content', content);
    };

    // Basic meta tags
    updateMetaTag('description', description, 'name');
    updateMetaTag('keywords', keywords, 'name');

    // Open Graph meta tags
    updateMetaTag('og:title', title);
    updateMetaTag('og:description', description);
    updateMetaTag('og:image', image);
    updateMetaTag('og:url', url);
    updateMetaTag('og:type', type);
    updateMetaTag('og:site_name', siteName);

    // Twitter Card meta tags
    updateMetaTag('twitter:card', image ? 'summary_large_image' : 'summary', 'name');
    updateMetaTag('twitter:title', title, 'name');
    updateMetaTag('twitter:description', description, 'name');
    if (image) {
      updateMetaTag('twitter:image', image, 'name');
    }

    // LinkedIn specific
    updateMetaTag('linkedin:owner', siteName);

    // Additional SEO meta tags
    updateMetaTag('robots', 'index,follow', 'name');
    updateMetaTag('author', siteName, 'name');

    // Cleanup function to remove meta tags when component unmounts
    return () => {
      const metaTags = [
        'description', 'keywords', 'author', 'robots',
        'og:title', 'og:description', 'og:image', 'og:url', 'og:type', 'og:site_name',
        'twitter:card', 'twitter:title', 'twitter:description', 'twitter:image',
        'linkedin:owner'
      ];

      metaTags.forEach(tag => {
        const nameTag = document.querySelector(`meta[name="${tag}"]`);
        const propertyTag = document.querySelector(`meta[property="${tag}"]`);
        
        if (nameTag && nameTag.getAttribute('content') !== '') {
          // Only remove if it was set by this component (has content)
          nameTag.remove();
        }
        if (propertyTag && propertyTag.getAttribute('content') !== '') {
          propertyTag.remove();
        }
      });
    };
  }, [title, description, image, url, type, siteName, keywords]);

  // This component doesn't render anything
  return null;
};

export default MetaTags;
